import Model from "./Model";
import * as moment from 'moment';
import Product from "./Product";
import Order from "./Order";
import PaymentDetail from "./PaymentDetail";
import PaymentItem from "./PaymentItem";
import ArrayList from "./ArrayList";
import Currency from "./Currency";

class Payment extends Model {
  constructor(options) {
    super();
    (this as any).product = d => {
      return new Product(d.data);
    };
    (this as any).order = d => {
      return new Order(d.data);
    };
    (this as any).default_payment_detail = d => {
      return new PaymentDetail(d.data);
    };
    (this as any).currency = d => {
      return new Currency(d.data);
    };
    (this as any).payment_items = d => {
      return new ArrayList<PaymentItem>(PaymentItem, d.data);
    };
    this.bind(options);
  }
}

export default Payment;
